module.exports = __webpack_public_path__ + "static/img/manual-29.787a5ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-29.png
// module id = CdqB
// module chunks = 4